/**
 * Online/offline detection for the stale-price banner (feature #6).
 * Uses the browser's navigator.onLine + events; works inside the Capacitor
 * WebView too. (@capacitor/network could be added later for finer signal.)
 */

export type NetworkListener = (online: boolean) => void;

export function getOnline(): boolean {
  return typeof navigator !== 'undefined' ? navigator.onLine : true;
}

export function subscribeNetwork(listener: NetworkListener): () => void {
  const on = () => listener(true);
  const off = () => listener(false);
  window.addEventListener('online', on);
  window.addEventListener('offline', off);
  return () => {
    window.removeEventListener('online', on);
    window.removeEventListener('offline', off);
  };
}
